/** Shared by ClusterReport table + CSV/PDF exports (same rules as on-screen columns). */

export function getCourseTotalQuestions(course) {
  const fromIds = Array.isArray(course?.question_ids) ? course.question_ids.length : 0;
  const fromCounts =
    (course?.easy_count || 0) + (course?.medium_count || 0) + (course?.hard_count || 0);
  return fromIds || fromCounts;
}

export function getCourseCompleted(course, student) {
  // If courseBreakdown is present (even if empty), use ONLY courseBreakdown data
  if (student?.courseBreakdown !== undefined) {
    if (Array.isArray(student.courseBreakdown) && student.courseBreakdown.length > 0) {
      const breakdown = student.courseBreakdown.find(
        (cb) => cb?.courseId === course?.id || cb?.courseName === course?.name
      );
      if (breakdown && breakdown.completedQuestions != null) {
        return breakdown.completedQuestions;
      }
    }
    // courseBreakdown is empty or course not found in breakdown - return 0
    return 0;
  }

  // Fallback to calculation from completedQuestions array (for backward compatibility)
  const completedIds = student?.student?.completedQuestions || [];
  const courseIds = course?.question_ids || [];
  if (courseIds.length === 0) return student?.completedQuestions ?? 0;
  return courseIds.filter((qId) => completedIds.includes(qId)).length;
}

export function hasCourseBreakdownData(course, student) {
  // Check if courseBreakdown exists and has data for this course
  if (!student?.courseBreakdown || !Array.isArray(student.courseBreakdown) || student.courseBreakdown.length === 0) {
    return false;
  }
  const breakdown = student.courseBreakdown.find(
    (cb) => cb?.courseId === course?.id || cb?.courseName === course?.name
  );
  return breakdown && breakdown.completedQuestions != null;
}

export function escapeCsvField(val) {
  const s = String(val ?? "");
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}
